import IncentiveRecap from "@/views/hlagons/incentives/IncentiveRecap";
import GiftCardsList from "@/views/hlagons/incentives/GiftCardsList";
import Deduplicates from "@/views/hlagons/deduplicates/Deduplicates";
import HomeHL from "@/views/hlagons/dashboard/HomeHL.vue";
import Crm from "@/views/hlagons/Crm";
import WorkshopList from "@/views/hlagons/workshop/WorkshopList.vue";
import AgentActivity from "@/views/hlagons/AgentActivity";
import CrmAgencyDetails from '@/views/stats/CrmAgencyDetails'
import Noop from '@/components/Noop'
import SuiviAgence from "@/views/hlagons/SuiviAgence.vue";
import Networks from "@/views/hlagons/Networks.vue";
import PaymentTerms from "@/views/hlagons/PaymentTerms.vue";
import CommercialListingHL from "@/views/hlagons/CommercialListingHL.vue";
import {Role} from "@/utils/user";
import CommercialLogs from "@/views/hlagons/commercialLogs/CommercialLogs.vue";
import EncoursAgence from "@/views/hlagons/EncoursAgence.vue";
import WorkshopDetails from "@/views/hlagons/workshop/WorkshopDetails.vue";
import MapAgencies from "@/views/hlagons/MapAgencies.vue";

const HLRoutes = [

    {
        path: '/hlagons', component: Noop,
        children: [
            {
                path: '/',
                name: 'HLagons',
                component: HomeHL,
                props: true,
                meta: {
                    roles: [Role.hlItaly, Role.commercial]
                }
            },
            {
                path: 'listing',
                name: 'CommercialListingBookingHL',
                component: CommercialListingHL,
                props: true,
                meta: {
                    roles: [Role.commercial]
                }
            },
            {
                path: 'incentives',
                name: 'IncentiveRecap',
                component: IncentiveRecap,
                props: true,
                meta: {
                    roles: [Role.commercialAdmin],
                    breadcrumb: [
                        {name: 'Hotels & lagons', route: {name: 'IncentiveRecap'}},
                        {name: 'Récapitulatif incentives'},
                    ]
                }
            },
            {
                path: 'giftcards',
                name: 'GiftCards',
                component: GiftCardsList,
                props: true,
                meta: {
                    roles: [Role.commercialAdmin],
                    breadcrumb: [
                        {name: 'Hotels & lagons', route: {name: 'IncentiveRecap'}},
                        {name: 'Chèques-cadeaux'},
                    ]
                }
            },
            {
                path: 'crm',
                name: 'Crm',
                component: Crm,
                props: true,
                meta: {
                    roles: [Role.hlItaly, Role.commercial],
                    breadcrumb: [
                        {name: 'Hotel & lagons', route: {name: 'IncentiveRecap'}},
                        {name: 'Crm'}
                    ]
                }
            },
            {
                path: 'crm/:id',
                name: 'CrmAgencyDetails',
                component: CrmAgencyDetails,
                props: true,
                meta: {
                    roles: [Role.hlItaly, Role.commercial],
                    breadcrumb: [
                        {name: 'Hotel & lagons', route: {name: 'IncentiveRecap'}},
                        {name: 'Crm', route: {name: 'Crm'}},
                        {name: 'Détails'}
                    ]
                }
            },
            {
                path: 'workshop',
                name: 'Workshop',
                component: WorkshopList,
                props: true,
                meta: {
                    roles: [Role.commercialAdmin, Role.commercial],
                    breadcrumb: [
                        {name: 'Hotel & lagons', route: {name: 'Workshop'}},
                        {name: 'Workshop', route: {name: 'Workshop'}}
                    ]
                }
            },
            {
                path: 'workshop/:workshopId',
                name: 'WorkshopDetails',
                component: WorkshopDetails,
                props: true,
                meta: {
                    roles: [Role.commercialAdmin, Role.commercial],
                    breadcrumb: [
                        {name: 'Hotel & lagons', route: {name: 'WorkshopDetails'}},
                        {name: 'WorkshopDetails', route: {name: 'WorkshopDetails'}}
                    ]
                }
            },
            {
                path: 'agent-activity',
                name: 'AgentActivity',
                component: AgentActivity,
                props: false,
                meta: {
                    roles: [Role.hlItaly, Role.commercial],
                }
            }, {
                path: 'commercial-log',
                name: 'CommercialLogs',
                component: CommercialLogs,
                props: false,
                meta: {
                    roles: [Role.hlItaly, Role.commercial],
                },
            },

            {
                path: 'deduplicates',
                name: 'Deduplicates',
                component: Deduplicates,
                props: true,
                meta: {
                    roles: [Role.commercialAdmin],
                }
            },
            {
                path: 'suivi-agence',
                name: 'Suivi Agence',
                component: SuiviAgence,
                props: true,
                meta: {
                    roles: [Role.commercial],
                }
            },
            {
                path: 'networks',
                name: 'networks',
                component: Networks,
                props: true,
                meta: {
										roles: [Role.commercialAdmin]
                }
            },
            {
                path: 'payment-terms',
                name: 'PaymentTerms',
                component: PaymentTerms,
                props: true,
                meta: {}
            },
            {
                path: 'encours-agence',
                name: 'EncoursAgence',
                component: EncoursAgence,
                props: true,
                meta: {
                    roles: [Role.commercialAdmin],
                }
            },
            {
                path: 'carte',
                name: 'MapAgencies',
                component: MapAgencies,
                props: true,
                meta: {
                    roles: [Role.commercialAdmin, Role.commercial],
                }
            }
        ]
    }

]

export default HLRoutes